module.exports = __webpack_public_path__ + "static/media/metamask-dark.2137a831.png";